import { Box, Tooltip } from '@mui/material';

import icon_snmp from 'assets/images/icons/icn_Info_solid.svg';
import icon_snmp_hover from 'assets/images/icons/icn_info_solid_hover.svg';

export default function TooltipNotice({ tooltipTitle, placement = 'right' }) {
  return (
    <Tooltip title={tooltipTitle} placement={placement} arrow>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: 16,
          '& img': {
            content: `url(${icon_snmp})`,
          },
          '&:hover img': {
            content: `url(${icon_snmp_hover})`,
          },
        }}
      >
        <img src={icon_snmp} alt="" style={{ width: 16, height: 16, cursor: 'pointer' }} />
      </Box>
    </Tooltip>
  );
}
